import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import PageHeader from '../../components/public/PageHeader';
import { publicApi } from '../../services/api';

export default function BlogDetailPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      setError('Artikel tidak ditemukan.');
      return;
    }

    let isMounted = true;
    setLoading(true);
    setError(null);

    publicApi.getPost(slug)
      .then(res => {
        if (!isMounted) return;
        const payload = res.data?.data ?? res.data ?? null;
        const data = payload?.data ?? payload ?? null;
        setPost(data);
        if (!data) setError('Artikel tidak ditemukan.');
      })
      .catch(err => {
        if (!isMounted) return;
        if (err.response?.status === 404) setError('Artikel tidak ditemukan.');
        else setError('Gagal memuat artikel.');
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [slug]);

  const formatDate = (dateStr) => {
    try {
      return new Date(dateStr).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' });
    } catch { return dateStr; }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-light">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500">Memuat artikel...</p>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <div className="min-h-[70vh] flex items-center justify-center bg-bg-light pt-20">
          <div className="text-center bg-white p-8 rounded-2xl shadow-lg max-w-md">
            <span className="text-4xl mb-4 block">📝</span>
            <p className="text-gray-600 mb-4">{error || 'Artikel tidak ditemukan.'}</p>
            <Link to="/blog" className="inline-block bg-brand text-navy px-6 py-2 rounded-full font-semibold hover:bg-brand-dark transition-colors">
              Kembali ke Blog
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Navbar />
      <PageHeader title={post.title} />
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 rounded-3xl overflow-hidden border border-gray-100 shadow-sm bg-gray-50">
            {post.image_url ? (
              <img src={post.image_url} alt={post.title} className="w-full h-72 md:h-96 object-cover object-center" />
            ) : (
              <div className="w-full h-72 md:h-96 flex items-center justify-center bg-gradient-to-br from-brand/20 via-white to-primary/20 text-6xl">
                📝
              </div>
            )}
          </div>
          <div className="flex flex-wrap items-center gap-3 mb-8 text-sm text-gray-500">
            <span className="bg-gray-100 px-3 py-1 rounded-full">{formatDate(post.created_at)}</span>
            {post.user?.name && <span className="bg-gray-100 px-3 py-1 rounded-full">{post.user.name}</span>}
          </div>
          {post.excerpt && <p className="text-lg text-gray-600 mb-8 italic border-l-4 border-brand pl-4">{post.excerpt}</p>}
          <div
            className="prose prose-gray max-w-none prose-img:rounded-2xl"
            dangerouslySetInnerHTML={{ __html: post.body || '' }}
          />
          <div className="mt-12 pt-8 border-t border-gray-200">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 text-navy hover:text-brand font-semibold transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Kembali ke Blog
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
